import React, { useEffect, useState } from "react";
import "./QuoteForm.css";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Row,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import emailjs from "emailjs-com";
import Link from "gatsby-link";

const SubmitStatus = {
  SUBMITTING: "submitting",
  NOT_SUBMITTED: "notSubmitted",
  SUCCESS: "success",
  FAILURE: "failure",
};

function makeRef() {
  let text = "";
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

  for (let i = 0; i < 10; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

export default function QuoteForm({ isInModal, modalData, isForQuote }) {
  const [quoteRef, setQuoteRef] = useState(makeRef());
  const [successQuoteRef, setSuccessQuoteRef] = useState("");
  
  const [name, setName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");
  const [newFiles, setFiles] = useState([]);
  const [formSubmittedStatus, setFormSubmittedStatus] = useState(
    SubmitStatus.NOT_SUBMITTED
  );

  const [address, setAddress] = useState("");
  const [suburb, setSuburb] = useState("");
  const [postcode, setPostcode] = useState("");
  const [state, setState] = useState("Victoria");

  const [jackQuantity, setJackQuantity] = useState(0);
  const [testServiceType, setTestServiceType] = useState("One time only");

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [testDropdownOpen, setTestDropdownOpen] = useState(false);
  const testToggle = () => setTestDropdownOpen((prevState) => !prevState);

  const [acceptTerms, setAcceptTerms] = useState(false);

  useEffect(() => {
    if (isInModal) {
      setDescription(
        "This is a shopping quote enquiry. Find a list of requested products below."
      );
    }
  }, [isInModal]);

  const clearFields = () => {
    setName("");
    setBusinessName("");
    setEmail("");
    setPhone("");
    setDescription("");
    setFiles([]);
    setAddress("");
    setSuburb("");
    setPostcode("");
    setState("Victoria");
    setDropdownOpen(false);
    setAcceptTerms(false);
    setQuoteRef(makeRef());
  };

  const onFilesChange = (e) => {
    const { files } = e.target;
    const length = files.length + newFiles.length - 5;

    const addedFiles = [...files];
    if (length > 0) {
      addedFiles.splice(files.length - length, length);
    }

    addedFiles.forEach((f, i) => {
      if (f.size > 10485760) {
        addedFiles.splice(i, 1);
      }
    });

    setFiles((prevState) => {
      return [...new Set([...prevState, ...addedFiles])];
    });
  };

  const onFileRemove = (index) => {
    setFiles((prevState) => {
      return prevState.filter((_, i) => {
        return i !== index;
      });
    });
  };

  function submit() {
    setFormSubmittedStatus(SubmitStatus.SUBMITTING);

    if (typeof window !== "undefined") {
      const { uploadFiles } = require("../businessLogic/Firebase");

      uploadFiles(newFiles)
        .then((urls) => {
          if (isInModal) {
            modalData
              .then((data) => {
                sendMail(urls, data);
              })
              .catch(() => {
                setFormSubmittedStatus(SubmitStatus.FAILURE);
              });
          } else {
            sendMail(urls, "");
          }
        })
        .catch(() => {
          setFormSubmittedStatus(SubmitStatus.FAILURE);
        });
    }
  }

  function sendMail(urls, additionalData) {
    emailjs
      .send(
        "service_r5owgql",
        "template_c1wniia",
        {
          ref: quoteRef,
          name: name,
          businessName: businessName,
          email: email,
          phone: phone,
          address: address + ", " + suburb + ", " + state + ", " + postcode,
          description: isForQuote
            ? description
            : "This is a testing service enquiry => Number of hydraulic jacks: " +
              jackQuantity +
              ", Requested service type: " +
              testServiceType +
              ".",
          urls:
            urls.length > 0
              ? "<ul><li>" + urls.join("</li><li>") + "</li></ul>"
              : "",
          items: additionalData,
          acceptTerms: acceptTerms ? "YES" : "NO",
        },
        "user_eeF8OQFcgsQzMVdUjTSsy"
      )
      .then(
        (_) => {
          setSuccessQuoteRef(quoteRef);
          setFormSubmittedStatus(SubmitStatus.SUCCESS);
          clearFields();
        },
        (_) => {
          setFormSubmittedStatus(SubmitStatus.FAILURE);
        }
      );
  }

  return isForQuote === undefined ? (
    <></>
  ) : (
    <Form className="mt-4">
      <Row>
        <Col sm={6}>
          <FormGroup>
            <Input
              type="text"
              name="name"
              placeholder="Name"
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
              value={name}
            />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup>
            <Input
              type="text"
              name="businessName"
              placeholder="Business Name"
              required
              onChange={(e) => {
                setBusinessName(e.target.value);
              }}
              value={businessName}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <FormGroup>
            <Input
              type="email"
              name="email"
              placeholder="Email Address"
              required
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              value={email}
            />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup>
            <Input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              required
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              value={phone}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <FormGroup>
            <Input
              type="text"
              name="address"
              placeholder="Address Line"
              required
              onChange={(e) => {
                setAddress(e.target.value);
              }}
              value={address}
            />
          </FormGroup>
        </Col>
        <Col md={5}>
          <FormGroup>
            <Input
              type="text"
              name="suburb"
              placeholder="Suburb"
              required
              onChange={(e) => {
                setSuburb(e.target.value);
              }}
              value={suburb}
            />
          </FormGroup>
        </Col>
        <Col sm={6} md={4}>
          <FormGroup className="dropdownGroup">
            <Dropdown
              group
              isOpen={dropdownOpen}
              toggle={toggle}
              className="dropdown"
            >
              <DropdownToggle caret className="dropdownToggle">
                {state === "" ? "State" : state}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    setState("Victoria");
                  }}
                >
                  Victoria
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </FormGroup>
        </Col>
        <Col sm={6} md={3}>
          <FormGroup>
            <Input
              type="number"
              min="1000"
              name="postcode"
              placeholder="Postcode"
              required
              onChange={(e) => {
                setPostcode(e.target.value);
              }}
              value={postcode}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row hidden={isInModal || !isForQuote}>
        <Col>
          <FormGroup>
            <Input
              type="textarea"
              name="description"
              placeholder="Provide details of your defective equipment (hydraulic jack models, defects, etc)"
              required
              onChange={(e) => {
                setDescription(e.target.value);
              }}
              value={description}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row hidden={isForQuote} className={"mb-5"}>
        <Col xs={12} className={"mt-5 mb-3"}>
          <label className="text-center titleLabel" htmlFor={"quantityInput"}>
            Please specify if you are only applying for one-time only or regular
            services and provide the number of hydraulic jacks you would like to
            apply for testing.
          </label>
        </Col>
        <Col xs={12} sm={6}>
          <FormGroup className="dropdownGroup">
            <Dropdown
              group
              isOpen={testDropdownOpen}
              toggle={testToggle}
              className="dropdown"
            >
              <DropdownToggle caret className="dropdownToggle">
                {testServiceType === "" ? "Service Type" : testServiceType}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    setTestServiceType("One time only");
                  }}
                >
                  One time only
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setTestServiceType("Regular");
                  }}
                >
                  Regular
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </FormGroup>
        </Col>
        <Col xs={12} sm={6}>
          <FormGroup>
            <Input
              type={"number"}
              id={"quantityInput"}
              onChange={(e) => {
                setJackQuantity(parseInt(e.target.value, 10));
              }}
              value={jackQuantity}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row className={"mb-2 mt-3"} hidden={isInModal || !isForQuote}>
        <Col xs={12}>
          <label className="text-left titleLabel" htmlFor={"fileUpload"}>
            Please upload images from your defective equipment. Maximum 5 files
            can be uploaded. Each file must not exceed 10MB in size. <br />
            Accepted formats: Zip, PDF, JPG, JPEG, PNG
          </label>
        </Col>
      </Row>
      <Row hidden={isInModal || !isForQuote}>
        <Col md={3}>
          <div className="fileUploadContainer">
            <label htmlFor="fileUpload" className="fileUpload">
              <i className="icofont-cloud-upload icofont-5x" />
              Upload Files
            </label>
            <input
              type="file"
              multiple
              id="fileUpload"
              onChange={onFilesChange}
              accept="image/vnd.sealedmedia.softseal.jpg, image/jpeg, 	image/vnd.sealed.png, image/png, application/pdf, application/vnd.sealedmedia.softseal.pdf, application/zip, .pdf, .jpg, .jpeg, .png, .zip"
            />
          </div>
        </Col>
        <Col md={9}>
          <Row>
            {newFiles.map((file, i) => (
              <Col xs={12} md={6} key={i}>
                <p className="text-left">
                  {" "}
                  {file.name}
                  <i
                    className="icofont-bin ml-2 deleteIcon"
                    role={"button"}
                    tabIndex={i}
                    title="Delete File"
                    aria-label="Delete File"
                    onClick={() => onFileRemove(i)}
                    onKeyDown={() => onFileRemove(i)}
                  />
                </p>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
      <Row className={"mt-2"}>
        <Col xs={"12 my-auto"}>
          Learn more about our{" "}
          <a href={"/safety"} target={"_blank"} rel="noreferrer">
            technical & safety warnings and advices
          </a>
          .
        </Col>
      </Row>
      <Row className={"mt-2"}>
        <Col xs={"12 my-auto"}>
          <input
            type="checkbox"
            id="termsCheck"
            checked={acceptTerms}
            onChange={(e) => {
              setAcceptTerms(e.target.checked);
            }}
          />
          <label htmlFor={"termsCheck"}>
            I agree to{" "}
            <a href={"/terms"} target={"_blank"} rel="noreferrer">
              terms & conditions
            </a>
            .
          </label>
        </Col>
        <Col xs={"12"} className={"mb-2 mt-3"}>
          <Button
            color="primary"
            onClick={submit}
            disabled={
              formSubmittedStatus === SubmitStatus.SUBMITTING ||
              formSubmittedStatus === SubmitStatus.SUCCESS ||
              name === "" ||
              email === "" ||
              (isForQuote
                ? description === ""
                : jackQuantity === 0 || testServiceType === "") ||
              businessName === "" ||
              phone === "" ||
              address === "" ||
              suburb === "" ||
              postcode === "" ||
              state === "" ||
              acceptTerms === false
            }
          >
            {formSubmittedStatus === SubmitStatus.SUBMITTING ? (
              <>
                <span
                  className="spinner-grow spinner-grow-sm mr-1"
                  role="status"
                  aria-hidden="true"
                />
                Requesting ...
              </>
            ) : (
              "Submit your request"
            )}
          </Button>
        </Col>
        <Col xs={"12"} className={"my-auto"}>
          {formSubmittedStatus === SubmitStatus.SUCCESS ? (
            <p className={"my-auto align-middle text-success"}>
              Thank you, your request has been submitted! <br />
              Please keep your reference number for future correspondence:{" "}
              <strong>{successQuoteRef}</strong>
            </p>
          ) : formSubmittedStatus === SubmitStatus.FAILURE ? (
            <p className={"my-auto align-middle text-danger"}>
              There was an error in submitting your request. Please try again.
            </p>
          ) : (
            ""
          )}
        </Col>
      </Row>
    </Form>
  );
}
